import * as types from "./types";
import ActionType from "../../Models/ActionType";

export const fetchContracts: () => ActionType = () => ({
  type: types.FETCH_CONTRACTS,
});
